"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.thirdPartyMonoIconKeys = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ThirdPartyMonoIcons = _interopRequireWildcard(require("../../../assets/icons/thirdpartymono/icons"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ** Third Party mono colour icon set   **
 */
var ThirdPartyMonoIcon = function ThirdPartyMonoIcon(_ref) {
  var icon = _ref.icon;
  return icon !== "" && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    component: ThirdPartyMonoIcons[icon],
    fontSize: "large",
    viewBox: "0 0 32 32"
  });
};

ThirdPartyMonoIcon.propTypes = {
  /** The ThirdPartyMono icon key */
  icon: _propTypes.default.string.isRequired
};
var thirdPartyMonoIconKeys = Object.keys(ThirdPartyMonoIcons);
exports.thirdPartyMonoIconKeys = thirdPartyMonoIconKeys;
var _default = ThirdPartyMonoIcon;
exports.default = _default;